import func from '../libs/functions';

const accounts = {
	namespaced: true,
	state: {
		accounts: null,
		activeAccounts: [],
		accountsById: {},
		accountsByPId: {},
		accountsByName: {},
		workspaceAccounts: [],
		workspaceAccountsById: {},
		workspaceAccountsByPId: {}
	},
	getters: {
		accounts(state){
			return state.accounts
		},
		activeAccounts(state){
			return state.activeAccounts
		},
		accountsById(state){
			return state.accountsById
		},
		accountsByPId(state){
			return state.accountsByPId
		},
		accountsByName(state){
			return state.accountsByName
		},
		workspaceAccounts(state){
			return state.workspaceAccounts
		},
		workspaceAccountsById(state){
			return state.workspaceAccountsById
		},
		workspaceAccountsByPId(state){
			return state.workspaceAccountsByPId
		}
	},
	mutations: {
		setAccounts(state, accounts){
			accounts = _.map(accounts, page => {
				if(!page.name) page.name = page.screenName;
				if(!page.avatar) page.avatar = '/img/social/gmb.png' //Googe My Business
				if(page.platform == '642ae982399fe2be2591aa48') page.avatar = '/img/socialSvg/trustPilot2.jpg'
				return page
			})
			state.accounts = accounts
			state.accountsById = func.arrayToObject(accounts, '_id')
			state.accountsByPId = func.arrayToObject(accounts, 'id')
			state.accountsByName = func.arrayToObject(accounts, 'name')				
		},
		setWorkspaceAccounts(state, accounts){
			accounts = _.map(accounts, page => {
				if(!page.name) page.name = page.screenName;
				if(!page.avatar) page.avatar = '/img/social/gmb.png'
				if(page.platform == '642ae982399fe2be2591aa48') page.avatar = '/img/socialSvg/trustPilot2.jpg'
				return page
			})
			state.workspaceAccounts = accounts
			state.workspaceAccountsById = func.arrayToObject(accounts, '_id')
			state.workspaceAccountsByPId = func.arrayToObject(accounts, 'id') //Googe My Business		
		},
		removeChannel(state, index){
			state.accounts.splice(index,1);
		}
	},
	actions: {
		setAccounts({ commit }, accounts){
			commit('setAccounts', accounts)
		},
		setWorkspaceAccounts({ commit }, accounts){
			commit('setWorkspaceAccounts', accounts)
		},
		removeChannel({ commit }, index){
			commit('removeChannel', index)
		}
	}
}

export default accounts;


// WEBPACK FOOTER //
// ./src/store/accounts.js